import React from "react";

import { Image as AntImage, ImageProps as AntImageProps } from "antd";

import { Spin } from "components";

type CustomImage = {
  s: string;
  l: string;
  className: string;
  URL: string;
};

type ImageProps = AntImageProps & {
  dataTestId?: string;
  images: Array<CustomImage>;
  key: string;
  onVisibleChange?: () => void;
  hidePreview?: boolean;
};

export const Image = ({ dataTestId, images, src, hidePreview, key, onVisibleChange, ...props }: ImageProps) =>
  src ? (
    <AntImage
      src={src}
      key={key}
      placeholder={<Spin style={{ display: hidePreview ? "none" : "block" }} dataTestId={dataTestId} />}
      style={{ display: hidePreview ? "none" : "block" }}
      preview={
        hidePreview
          ? {
              visible: !!src,
              src: src,
              onVisibleChange: onVisibleChange,
            }
          : {}
      }
      {...props}
    />
  ) : images && images.length > 0 ? (
    <AntImage.PreviewGroup>
      {images.map((img, i) => {
        if (img && img.s) {
          return (
            <AntImage
              src={img.s}
              className={img.className}
              key={i}
              placeholder={<Spin dataTestId={`${dataTestId}-placeholder`} />}
              preview={{
                src: img.l, // for unknown reasons, the preview image is the one that opens when clicked :|
              }}
              {...props}
            />
          );
        }
        if (img && img.URL) {
          return <AntImage src={img.URL} className={img.className} key={i} placeholder={<Spin dataTestId={`${dataTestId}-placeholder`} {...props} />} />;
        }
        return undefined;
      })}
    </AntImage.PreviewGroup>
  ) : null;

export default Image;
